import {
  isExternalMedia,
  isExternalMediaWeblink,
  isMedialinkStudentAssignment,
  isMiniSite,
  Medialink,
} from '../modules/material/_api/MedialinksApi';

/**
 * @deprecated use getLinkFromMedialink from api instead
 */
export function getLinkFromMedialink(medialink: Medialink) {
  if (isMiniSite(medialink) && medialink.miniSite?.target === 'new-window') {
    return medialink.miniSite.href;
  }

  if (
    isExternalMedia(medialink) &&
    isExternalMediaWeblink(medialink) &&
    medialink.externalMedia.target === 'new-window'
  ) {
    return medialink.externalMedia.href;
  }

  return;
}

/**
 * @deprecated use validateAndGetLinkFromMedialink from api instead
 */
export function validateAndGetLinkFromMedialink(medialink: Medialink) {
  if (isMedialinkStudentAssignment(medialink)) return undefined;

  return getLinkFromMedialink(medialink);
}

export const EXERCISE_KINDS = ['exercise-edumatic', 'exercise-eduhint', 'exercise-assessmentq'];

/**
 * @deprecated use isScorableMedialink from api instead
 */
export function checkIsExercise(kind: string) {
  return EXERCISE_KINDS.includes(kind);
}

type MedialinkWithHierarchy = { hierarchy: Array<{ id: string }> };

export const groupMedialinksByNode = <T extends MedialinkWithHierarchy>(medialinks: T[]) => {
  return medialinks.reduce<Record<string, T[]>>((groupedMedialinks, medialink) => {
    const node = medialink.hierarchy[medialink.hierarchy.length - 1];

    if (!node) return groupedMedialinks;

    return {
      ...groupedMedialinks,
      [node.id]: [...(groupedMedialinks[node.id] || []), medialink],
    };
  }, {});
};
